// extracted by extract-css-chunks-webpack-plugin
module.exports = {"urgencyStatementWrapper":"zZM0c","coupon-livetextTheme":"H9laK","timeParentWrapper":"_2Jvjy","liveTextTimer":"_2yJtR","livetext-coupon":"bwRiS"};